import { initCalendarEvents } from './calendar'

export const celebreatCalendarEvents = () => {
  const nextButton = document.querySelector('button[data-js-celebreat-next]')
  const prevButton = document.querySelector('button[data-js-celebreat-prev]')
  const container = document.querySelector('[data-js-celebreat-days]')
  const loadingSpinnerFullpage = document.querySelector('[data-js-loading-spinner-fullpage]')

  if (!container || !nextButton || !prevButton) {
    return
  }

  const slideToShow = 5
  let currentIndex = 0
  let isLoading = false

  const getEventItems = () => Array.from(container.querySelectorAll('li.availability-calendar__day'))
  const getSeparators = () => Array.from(container.querySelectorAll('h3[data-separator-month]'))
  const getMonthLists = () => Array.from(container.querySelectorAll('ul.availability-calendar__list'))
  let eventItems = getEventItems()

  const refreshItems = () => { eventItems = getEventItems() }

  const hideAll = () => {
    eventItems.forEach(item => {
      item.setAttribute('hidden', '')
      item.setAttribute('aria-hidden', 'true')
    })
    getSeparators().forEach(sep => {
      sep.setAttribute('hidden', '')
      sep.setAttribute('aria-hidden', 'true')
    })
    getMonthLists().forEach(ul => {
      ul.setAttribute('hidden', '')
      ul.setAttribute('aria-hidden', 'true')
    })
  }

  const showParentLists = (items, seps) => {
    const lists = new Set()
    items.forEach(item => {
      const ul = item.closest('ul.availability-calendar__list')
      if (ul) lists.add(ul)
    })
    lists.forEach(ul => {
      ul.removeAttribute('hidden')
      ul.removeAttribute('aria-hidden')
    })
    seps.forEach(sep => {
      sep.removeAttribute('hidden')
      sep.removeAttribute('aria-hidden')
    })
  }

  // ── Buttons ──────────────────────────────────────────────
  const updateButtons = () => {
    // Prev: disabled only if at index 0 AND no previous months to load
    const canLoadPrev = !!container.dataset.jsPrevMonth
    if (currentIndex === 0 && !canLoadPrev) {
      prevButton.setAttribute('disabled', 'disabled')
    } else {
      prevButton.removeAttribute('disabled')
    }

    // Next: disabled only if no more items AND no more months to load
    const hasMoreInDom = currentIndex + slideToShow < eventItems.length
    const canLoadNext = !!container.dataset.jsNextMonth
    if (!hasMoreInDom && !canLoadNext) {
      nextButton.setAttribute('disabled', 'disabled')
    } else {
      nextButton.removeAttribute('disabled')
    }
  }

  // ── Month display ────────────────────────────────────────
  const updateMonthDisplay = () => {
    const firstVisible = eventItems[currentIndex]
    if (!firstVisible) return
    const month = firstVisible.dataset.month
    if (!month) return

    const locale = document.documentElement.lang || 'de'
    const dateParts = month.split('-')
    const date = new Date(dateParts[0], dateParts[1] - 1)
    const monthText = date.toLocaleString(locale, { month: 'long', year: 'numeric' })

    // h3 header
    const header = document.querySelector('[data-js-calendar-current-date]')
    if (header) {
      header.dataset.jsCalendarCurrentDate = month
      const img = header.querySelector('img')
      header.textContent = ''
      if (img) header.appendChild(img)
      header.appendChild(document.createTextNode(' ' + monthText))
    }

    // URL
    try {
      const path = window.location.pathname.replace(/\/\d{4}-\d{2}/, '')
      window.history.replaceState({}, '', path + '/' + month)
    } catch (e) {
      console.warn('URL update failed:', e)
    }

    // Dropdown button
    const btnSpan = document.querySelector('#monthSelectButton span:first-child')
    if (btnSpan) btnSpan.textContent = monthText

    // Dropdown selected link
    document.querySelectorAll('.dropdown-menu__label').forEach(link => {
      const href = link.getAttribute('href') || ''
      link.classList.toggle('dropdown-menu__label--selected', href.includes(month))
    })
  }

  // ── Animation ────────────────────────────────────────────
  const transitionDuration = 250
  let scrollDirection = 'down'
  const CSS_SLIDE_AWAY = 'availability-calendar__slide-away'
  const CSS_NO_TRANSITION = 'availability-calendar__no-transition'
  const CSS_ANIMATING_HEIGHT = 'availability-calendar__animating-height'

  const getPageSeparators = (pageItems) => {
    const seps = []
    let lastMonth = null
    pageItems.forEach(item => {
      const month = item.dataset.month
      if (month && lastMonth && month !== lastMonth) {
        const sep = container.querySelector('h3[data-separator-month="' + month + '"]')
        if (sep) seps.push(sep)
      }
      lastMonth = month
    })
    return seps
  }

  const clearAnimState = (el) => {
    el.classList.remove(CSS_SLIDE_AWAY, CSS_NO_TRANSITION)
    el.style.removeProperty('--stagger-index')
  }

  const showCurrentPage = (animate) => {
    const pageItems = eventItems.slice(currentIndex, currentIndex + slideToShow)
    const seps = getPageSeparators(pageItems)

    if (!animate) {
      hideAll()
      pageItems.forEach(item => {
        item.removeAttribute('hidden')
        item.removeAttribute('aria-hidden')
        item.classList.add('availability-calendar__day--active')
        clearAnimState(item)
      })
      seps.forEach(sep => {
        sep.removeAttribute('hidden')
        sep.removeAttribute('aria-hidden')
        clearAnimState(sep)
      })
      container.style.removeProperty('--slide-offset')
      showParentLists(pageItems, seps)
      updateButtons()
      updateMonthDisplay()
      return
    }

    const visibleItems = eventItems.filter(item => !item.hasAttribute('hidden'))
    const visibleSeps = getSeparators().filter(sep => !sep.hasAttribute('hidden'))
    const slideOut = scrollDirection === 'down' ? '-30px' : '30px'
    const slideIn = scrollDirection === 'down' ? '30px' : '-30px'

    // Phase 1: slide out
    container.style.setProperty('--slide-offset', slideOut)
    visibleItems.forEach((item, i) => {
      item.style.setProperty('--stagger-index', i)
      item.classList.add(CSS_SLIDE_AWAY)
    })
    visibleSeps.forEach(sep => {
      sep.classList.add(CSS_SLIDE_AWAY)
    })

    // Phase 2: swap and slide in
    setTimeout(() => {
      // Lock container height to prevent layout shift
      const startHeight = container.offsetHeight
      container.style.height = startHeight + 'px'
      container.classList.add(CSS_ANIMATING_HEIGHT)

      hideAll()
      container.style.setProperty('--slide-offset', slideIn)

      // Position items at start (no animation)
      pageItems.forEach((item, i) => {
        item.removeAttribute('hidden')
        item.removeAttribute('aria-hidden')
        item.classList.add('availability-calendar__day--active', CSS_NO_TRANSITION, CSS_SLIDE_AWAY)
        item.style.setProperty('--stagger-index', i)
      })
      seps.forEach(sep => {
        sep.removeAttribute('hidden')
        sep.removeAttribute('aria-hidden')
        sep.classList.add(CSS_NO_TRANSITION, CSS_SLIDE_AWAY)
      })
      showParentLists(pageItems, seps)

      // Measure target height, then animate from start to target
      container.style.height = ''
      const endHeight = container.offsetHeight
      container.style.height = startHeight + 'px'

      container.offsetHeight // eslint-disable-line no-unused-expressions

      container.style.height = endHeight + 'px'

      // Enable transitions and animate in
      pageItems.forEach(item => {
        item.classList.remove(CSS_NO_TRANSITION, CSS_SLIDE_AWAY)
      })
      seps.forEach(sep => {
        sep.classList.remove(CSS_NO_TRANSITION, CSS_SLIDE_AWAY)
      })

      // Cleanup after animation
      setTimeout(() => {
        pageItems.forEach(item => { item.style.removeProperty('--stagger-index') })
        container.style.height = ''
        container.classList.remove(CSS_ANIMATING_HEIGHT)
        container.style.removeProperty('--slide-offset')
      }, transitionDuration + 250)

      updateButtons()
      updateMonthDisplay()
    }, transitionDuration)
  }

  // ── AJAX: load a month and append/prepend items ──────────
  const loadMonth = (direction) => {
    if (isLoading) return Promise.resolve(false)

    const attr = direction === 'next' ? 'jsNextMonth' : 'jsPrevMonth'
    const lastMonth = container.dataset[attr]
    if (!lastMonth) return Promise.resolve(false)

    const parts = lastMonth.split('-')
    const targetDate = new Date(parts[0], parts[1] - 1)
    targetDate.setMonth(targetDate.getMonth() + (direction === 'next' ? 1 : -1))

    const calendarUrl = container.dataset.jsCalendarUrl
    const productId = container.dataset.jsProductId
    if (!calendarUrl || !productId) return Promise.resolve(false)

    isLoading = true
    const params = new window.URLSearchParams({
      date: String(targetDate.getMonth() + 1).padStart(2, '0') + '-' + targetDate.getFullYear(),
      ticketId: productId,
      direction
    })
    const url = calendarUrl + '?' + params.toString()

    return window.fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(response.statusText)
        return response.json()
      })
      .then(data => {
        if (!data.html || !data.date) {
          delete container.dataset[attr]
          isLoading = false
          updateButtons()
          return false
        }

        const parser = new window.DOMParser()
        const doc = parser.parseFromString(data.html, 'text/html')
        const newItems = doc.querySelectorAll('li.availability-calendar__day')

        if (newItems.length === 0) {
          delete container.dataset[attr]
          isLoading = false
          updateButtons()
          return false
        }

        const responseParts = String(data.date).split('-')
        if (responseParts.length < 2) {
          console.warn('Unexpected date format:', data.date)
          isLoading = false
          return false
        }
        const responseMonth = responseParts[0] + '-' + String(responseParts[1]).padStart(2, '0')

        // Create new month list
        const newList = document.createElement('ul')
        newList.className = 'availability-calendar__list'
        newList.dataset.jsMonth = responseMonth
        newList.setAttribute('hidden', '')
        newList.setAttribute('aria-hidden', 'true')

        // Create month separator heading before the list
        const separatorMonth = direction === 'next'
          ? responseMonth
          : (eventItems[0] ? eventItems[0].dataset.month : responseMonth)
        let sepH3 = null
        if (!container.querySelector('h3[data-separator-month="' + separatorMonth + '"]')) {
          const locale = document.documentElement.lang || 'de'

          if (direction === 'next') {
            const h3Source = doc.querySelector('.availability-calendar__month')
            if (h3Source) {
              sepH3 = h3Source.cloneNode(true)
            } else {
              sepH3 = document.createElement('h3')
              sepH3.className = 'availability-calendar__month display-p large'
              const d = new Date(responseParts[0], responseParts[1] - 1)
              sepH3.textContent = d.toLocaleString(locale, { month: 'long', year: 'numeric' })
            }
          } else {
            sepH3 = document.createElement('h3')
            sepH3.className = 'availability-calendar__month display-p large'
            const sp = separatorMonth.split('-')
            const d = new Date(sp[0], sp[1] - 1)
            const h3Source = doc.querySelector('.availability-calendar__month')
            const imgTag = h3Source ? h3Source.querySelector('img') : null
            if (imgTag) sepH3.appendChild(imgTag.cloneNode(true))
            sepH3.appendChild(document.createTextNode(' ' + d.toLocaleString(locale, { month: 'long', year: 'numeric' })))
          }
          sepH3.dataset.separatorMonth = separatorMonth
          sepH3.classList.add('availability-calendar__month-separator')
          sepH3.setAttribute('hidden', '')
          sepH3.setAttribute('aria-hidden', 'true')
        }

        // Insert items into the new month list
        const itemsArray = Array.from(newItems)
        itemsArray.forEach(item => {
          item.setAttribute('hidden', '')
          item.setAttribute('aria-hidden', 'true')
          if (!item.dataset.month) item.dataset.month = responseMonth
          newList.appendChild(item)
        })

        // Append or prepend the month list (with heading before it)
        if (direction === 'next') {
          if (sepH3) container.appendChild(sepH3)
          container.appendChild(newList)
        } else {
          const firstChild = container.firstElementChild
          container.insertBefore(newList, firstChild)
          if (sepH3) container.insertBefore(sepH3, firstChild)
          // Adjust currentIndex since we prepended items
          currentIndex += itemsArray.length
        }

        // Update tracking month — check endDate
        const endMonth = container.dataset.jsEndMonth
        if (direction === 'next') {
          if (endMonth && responseMonth >= endMonth) {
            delete container.dataset.jsNextMonth
          } else {
            container.dataset.jsNextMonth = responseMonth
          }
        } else {
          const startMonth = container.dataset.jsStartMonth
          if (startMonth && responseMonth <= startMonth) {
            delete container.dataset.jsPrevMonth
          } else {
            container.dataset.jsPrevMonth = responseMonth
          }
        }

        refreshItems()
        initCalendarEvents()
        isLoading = false
        updateButtons()
        return true
      })
      .catch(() => {
        isLoading = false
        updateButtons()
        return false
      })
  }

  // ── Next button ──────────────────────────────────────────
  nextButton.addEventListener('click', () => {
    if (nextButton.disabled || isLoading) return
    scrollDirection = 'down'
    const nextIndex = currentIndex + slideToShow

    const tryShowNext = () => {
      if (nextIndex >= eventItems.length) {
        updateButtons()
        return
      }
      currentIndex = nextIndex
      updateButtons()
      showCurrentPage(true)
      // Pre-fetch if buffer low
      const remaining = eventItems.length - (currentIndex + slideToShow)
      if (remaining < slideToShow * 2 && container.dataset.jsNextMonth) {
        loadMonth('next')
      }
    }

    const itemsAfterNext = eventItems.length - nextIndex
    if (itemsAfterNext >= slideToShow) {
      tryShowNext()
    } else if (container.dataset.jsNextMonth) {
      if (loadingSpinnerFullpage) {
        loadingSpinnerFullpage.removeAttribute('hidden')
        loadingSpinnerFullpage.focus()
      }
      loadMonth('next').then(loaded => {
        if (loaded) {
          const stillNeeded = slideToShow - (eventItems.length - nextIndex)
          if (stillNeeded > 0 && container.dataset.jsNextMonth) {
            return loadMonth('next').then(() => tryShowNext())
          } else {
            tryShowNext()
          }
        } else if (nextIndex < eventItems.length) {
          tryShowNext()
        } else {
          updateButtons()
        }
      }).finally(() => {
        if (loadingSpinnerFullpage) loadingSpinnerFullpage.setAttribute('hidden', 'hidden')
      })
    } else if (nextIndex < eventItems.length) {
      tryShowNext()
    }
  })

  // ── Prev button ──────────────────────────────────────────
  prevButton.addEventListener('click', () => {
    if (prevButton.disabled || isLoading) return
    scrollDirection = 'up'

    if (currentIndex > 0) {
      currentIndex = Math.max(currentIndex - slideToShow, 0)
      updateButtons()
      updateMonthDisplay()
      showCurrentPage(true)
    } else if (container.dataset.jsPrevMonth) {
      // At index 0 but earlier months exist — load them
      if (loadingSpinnerFullpage) {
        loadingSpinnerFullpage.removeAttribute('hidden')
        loadingSpinnerFullpage.focus()
      }
      loadMonth('prev').then(loaded => {
        if (loaded) {
          // currentIndex was adjusted by loadMonth (prepend shifts it)
          // Go back to show the prepended items
          currentIndex = Math.max(currentIndex - slideToShow, 0)
          updateButtons()
          updateMonthDisplay()
          showCurrentPage(true)
        }
      }).finally(() => {
        if (loadingSpinnerFullpage) loadingSpinnerFullpage.setAttribute('hidden', 'hidden')
      })
    }
  })

  // ── Init ─────────────────────────────────────────────────
  showCurrentPage(false)

  // Pre-fetch next month in background (don't touch buttons)
  if (container.dataset.jsNextMonth) {
    loadMonth('next')
  }
}

celebreatCalendarEvents()
